
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adventures",
      function () {
        return require("private-next-pages/adventures.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adventures"])
      });
    }
  